import { UserSwitchOutlined } from '@ant-design/icons';
import { useImpersonation } from '@contexts/impersonation-context';
import { useTranslations } from '@i18n/use-translations';
import { useGetIdentity } from '@refinedev/core';
import { Button, Typography } from 'antd/es';

import { CurrentUserDTO } from '../../../../app/auth/dto';

const ImpersonationIndication = () => {
  const t = useTranslations('impersonation');
  const { isImpersonating, isLoading, stopImpersonation } = useImpersonation();
  const { data: currentUser } = useGetIdentity<CurrentUserDTO>();

  if (!isImpersonating) return null;

  const impersonatedUsername = `${currentUser?.family_name} ${currentUser?.given_name}`;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
        width: '100%',
        height: '100%',
        backgroundColor: '#5AB9D6',
      }}
    >
      <Typography.Paragraph style={{ marginBottom: '0px', color: 'white' }}>
        <UserSwitchOutlined style={{ color: 'white', marginRight: '5px' }} />
        {t('headerMessage')} <strong>{impersonatedUsername}</strong>
      </Typography.Paragraph>
      <Button
        disabled={isLoading}
        loading={isLoading}
        size="small"
        style={{ color: 'white', backgroundColor: 'transparent', borderWidth: 2 }}
        variant="outlined"
        onClick={stopImpersonation}
      >
        {t('switchBack')}
      </Button>
    </div>
  );
};

export { ImpersonationIndication };
